export const PRICING = {
    STRIKETHROUGH_TOGGLE: "PRICING_strikethrough_toggle",
};
